import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserNoteFilterEntity } from '../../domain/entities/UserNoteFilterEntity'

export class UserNoteFilterModel extends UserNoteFilterEntity {
  userId?: string
  adminUserId?: string
  constructor(dataDto: UserNoteFilterEntity) {
    super()
    mapEntityProperties<UserNoteFilterModel>(this, dataDto, {
      exclude: ['adminUser', 'user'],
      map: {
        userId: dataDto.user?.id,
        adminUserId: dataDto.adminUser?.id
      }
    })
  }
}
